
<div class="containers">
    <div class="header">

        <button *ngIf="!from"[disabled]="month==currentMonth && year==currentyear" mat-icon-button  class="arrowleft" (click)="goToPreviousMonth()">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <button *ngIf="from" mat-icon-button  class="arrowleft" (click)="goToPreviousMonth()">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="month-header">
            <h3>{{monthName}}-{{year}}</h3>
            
        </div>

        <button mat-icon-button  class="arrowright" (click)="goToNextMonth()">
            <mat-icon>chevron_right</mat-icon> </button>

    </div>
    <div class="calendar">
        <div class="weekdays">
            <ng-container *ngFor="let week of weeks">
                <div [ngClass]="{holiday: week=='SUN'||week=='SAT'}">{{week}}</div>
            </ng-container>

        </div>
        <ng-container *ngFor="let date of dates;">
            <app-calendarday [date]="date" [selecteddate]="selectedday" (newItemEvent)="getSelectedDate($event)"></app-calendarday>

        </ng-container>

    </div>


</div>

